<template>
    <div class="search-group template1">
        <div class="tab-header">
            <span
                v-for="(item, index) in searchGroupTabs"
                :class="`item ${activeIndex === index ? 'active' : ''}`"
                :key="item.id"
                @click="changeTab(index)"
                v-html="item.name"
            ></span>
        </div>
        <div class="tab-header mobile">
            <span
                v-for="(item, index) in searchGroupTabs"
                :class="`item ${activeIndex === index ? 'active' : ''}`"
                :key="item.id"
                @click="changeTab(index)"
                v-html="item.mobileModelName"
            ></span>
        </div>
        <div class="tab-body">
            <div
                v-for="(item, index) in searchGroupTabs"
                :key="item.id"
                :class="`tab-content ${activeIndex === index ? 'active' : ''}`"
            >
                <component
                    :is="searchBar"
                    v-if="item.inputComponentType === 'searchBar'"
                    v-show="activeIndex === index"
                    :submitText="item.submitText"
                    :placeholder="searchGroupConfig['placeholder-search']"
                    :autoSubmit="true"
                />
                <address-input
                    v-else-if="item.inputComponentType === 'addressInput'"
                    v-show="activeIndex === index"
                    :placeholder="
                        searchGroupConfig[
                            item.id === 1
                                ? 'placeholder-sell'
                                : 'placeholder-eval'
                        ]
                    "
                    v-model:searchText="searchText"
                    :submitText="item.submitText"
                    :chooseSuggestionAutoSubmit="false"
                    :mobileScroll="false"
                    @submitAddress="
                        (address, data, callback) =>
                            submitAddress(
                                { address, data, callback },
                                index,
                                item.submitType,
                                item.submitUrl
                            )
                    "
                />
            </div>
        </div>
        <div
            v-if="agreementData && agreementData.agreement"
            class="agreement-container"
        >
            <a
                :href="agreementData.agreementUrl || ''"
                class="agreement"
                target="_blank"
                rel="noopener noreferrer"
            >{{ agreementData.agreement }}</a>
        </div>
    </div>
</template>

<script>
import common from '../search-group';
import mixinsSearchBar from './mixins-search-bar';
import AddressInput from '../../../components/address-input/standard.vue';
export default {
    mixins: [common, mixinsSearchBar],
    components: {
        AddressInput
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';
.search-group.template1 {
    width: 100%;
    margin-top: 30px;
    padding: 30px 40px;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
    @include media-min-1080 {
        &.row {
            width: 480px;
            position: relative;
            padding: 30px;
            margin-top: 0;
            .tab-header {
                display: none;
                &.mobile {
                    display: flex;
                }
            }
        }
    }
    .tab-header {
        display: flex;
        width: 100%;
        height: 20px;
        background-color: transparent;

        &.mobile {
            display: none;
        }

        .item {
            position: relative;
            margin-right: 40px;
            line-height: 20px;
            font-family: var(--font-medium);
            font-size: 16px;
            cursor: pointer;

            &.active {
                color: var(--mg-button-background);
            }

            &.active::before {
                content: '';
                position: absolute;
                left: 0;
                bottom: -14px;
                width: 100%;
                height: 2px;
                background-color: var(--mg-button-background);
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .tab-body {
        width: 100%;
        margin-top: 40px;
        .tab-content {
            width: 100%;
            display: none;

            &.active {
                display: block;

                .address-input {
                    width: 100%;
                }
            }

            .search-bar {
                margin-top: 0;
                .search-by-section {
                    .icon-search {
                        display: none;
                    }
                    .search-input {
                        padding-left: 20px;
                        border: 1px solid transparent;
                    }
                }
            }

            .address-input {
                .left-box {
                    .input {
                        border-radius: 2px 0 0 2px;
                        color: #202437;
                    }
                    .close-box .icon-search-close::before {
                        color: #c6c8d1;
                    }
                }
                .right-box {
                    .submit-btn {
                        @include color-button-hover();
                        font-size: 16px;
                        width: 120px;
                        @include color-button();
                    }
                }
            }
        }
    }
    .agreement-container {
        width: 100%;
        margin-top: 20px;
        padding: 0 15px;
        .agreement {
            width: 100%;
            font-size: 12px;
            text-align: center;
            @include webkitBox(3);
            line-height: 14px;
            color: #fff;
            &:hover {
                @include color-hover();
                @include media-800 {
                    color: #fff;
                }
            }
        }
    }
    @include media-800 {
        border-radius: 0;
        box-shadow: none;
        padding: 20px 10px 0;
        padding-top: 10px;
        // background-color: transparent;
        margin-top: 20px;
        .tab-header {
            display: none;
            &.mobile {
                display: flex;
                height: 35px;
                justify-content: center;
                .item {
                    line-height: 35px;
                    height: 35px;
                    color: var(--mg-button-background);
                    text-align: center;
                    color: white;
                    &:not(:last-child) {
                        margin-right: 20px;
                    }
                    &.active {
                        &:before {
                            bottom: 0;
                        }
                    }
                }
            }
        }

        .tab-body {
            margin-top: 20px;
            .tab-content {
                height: 46px;
                .search-bar {
                    .search-by-section {
                        border-bottom: none;
                        padding: 0 15px;
                        .search-category {
                            border: none;
                            height: 46px;
                            line-height: 46px;
                            .keyword {
                                .search-input {
                                    height: 46px;
                                    padding-left: 10px;
                                    border-radius: 3px 0 0 3px;
                                    border: 1px solid rgba(100, 100, 100, 0.5);
                                    border-right: none;
                                }
                            }
                            .keyword-submit {
                                @include color-button-hover();
                                font-size: 14px;
                                width: auto;
                                padding: 0 10px;
                                height: 46px;
                                line-height: 46px;
                                border-radius: 0 3px 3px 0;
                                @include color-button();
                            }
                        }
                    }
                }

                .address-input {
                    box-shadow: none;
                    height: 46px;
                    .left-box {
                        height: 100%;
                        .iconfont {
                            display: none;
                        }
                        .input {
                            height: 100%;
                            padding-left: 10px;
                            border-radius: 3px 0 0 3px;
                            border: 1px solid rgba(100, 100, 100, 0.5);
                            border-right: none;
                        }
                    }
                    .right-box {
                        display: block;
                        .submit-btn {
                            border-radius: 0 3px 3px 0;
                            height: 46px;
                            line-height: 46px;
                            font-size: 14px;
                            padding: 0 10px;
                            .submit {
                                line-height: 46px;
                            }
                            .iconfont {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
